import { createBrowserRouter } from "react-router-dom";
import { IndexPage } from "./pages/index";
import { ErrorPage } from "./pages/ErrorPage";
import { Home } from "./pages/Home";
import { Unit } from "./pages/Unit";
import { Info } from "./pages/Info";
import { Resource } from "./pages/Resource";
import { Repair } from "./pages/Repair";
import { Procurement } from "./pages/Procurement";
import { Plan } from "./pages/Plan";
import { Login } from "./pages/Login";
import { MainPage } from "./pages/admin/main";
import { Resourced } from "./pages/admin/Resourced";
import { Announce } from "./pages/admin/Announce";
import { AnnounceContent } from "./pages/admin/AnnounceContent";
import { SoftwareAuth } from "./pages/admin/SoftwareAuth";
import { NewsView } from "./pages/NewsView";
import { NewsAll } from "./pages/NewsAll";
import { Activity } from "./pages/Activity";
import { CalendarPage } from "./pages/CalendarPage";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { Origin } from "./pages/Origin";
import { Bilingual } from "./pages/Bilingual";
import { Digital } from "./pages/Digital";
import { Star } from "./pages/Star";
import { Schoolmaster } from "./pages/Schoolmaster";
import { Contest } from "./pages/Contest";
import { Download } from "./pages/Download";
import { Moemdm } from "./pages/Moemdm";
import { ProcureList } from "./pages/ProcureList";
import { Sitemap } from "./pages/Sitemap";
import { AIcontest } from "./pages/AIcontest";
import { Lecturer } from "./pages/Lecturer";

export const useRouter = () => {
  return createBrowserRouter([
    {
      path: "/",
      element: <IndexPage />,
      errorElement: <ErrorPage />,
      children: [
        {
          index: true,
          element: <Home />,
        },
        {
          path: "unit",
          element: <Unit />,
        },
        {
          path: "info",
          element: <Info />,
        },
        {
          path: "resource",
          element: <Resource />,
        },
        {
          path: "repair",
          element: <Repair />,
        },
        {
          path: "procurement",
          element: <Procurement />,
        },
        {
          path: "procurelist",
          element: <ProcureList />,
        },
        {
          path: "plan",
          element: <Plan />,
        },
        {
          path: "newsview",
          element: <NewsView />,
        },
        {
          path: "newsall",
          element: <NewsAll />,
        },
        {
          path: "activity",
          element: <Activity />,
        },
        {
          path: "calendar",
          element: <CalendarPage />,
        },
        {
          path: "privacy-policy",
          element: <PrivacyPolicy />,
        },
        {
          path: "origin",
          element: <Origin />,
        },
        {
          path: "digital",
          element: <Digital />,
        },
        {
          path: "bilingual",
          element: <Bilingual />,
        },
        {
          path: "star",
          element: <Star />,
        },
        {
          path: "schoolmaster",
          element: <Schoolmaster />,
        },
        {
          path: "contest",
          element: <Contest />,
        },
        {
          path: "moemdm",
          element: <Moemdm />,
        },
        {
          path: "download",
          element: <Download />,
        },
        {
          path: "sitemap",
          element: <Sitemap />,
        },
        {
          path: "aicontest",
          element: <AIcontest />,
        },
        {
          path: "lecturer",
          element: <Lecturer />,
        },
      ]
    },
    {
      path: "login",
      element: <Login />,
    },
    {
      path: "main",
      element: <MainPage />,
      children: [
        {
          index: true,
          element: <Resourced />,
        },
        {
          path: "announce",
          element: <Announce />,
        },
        {
          path: "content",
          element: <AnnounceContent />,
        },
        {
          path: "software",
          element: <SoftwareAuth />,
        },
      ]
    },
  ]);
}
